<template>
  <v-dialog v-model="dialog" max-width="400" persistent>
    <template v-slot:activator="{ on, attrs }">
      <span v-on="on" v-bind="attrs">
        <v-text-field
          v-bind="{
            rules,
            label,
            prependInnerIcon,
            outlined,
            rounded,
            dense,
            required,
            placeholder,
          }"
          :class="className"
          :value="showedValue"
          readonly
        />
      </span>
    </template>
    <v-card class="text-center">
      <v-tabs v-model="tab" fixed-tabs>
        <v-tabs-slider />
        <v-tab href="#tab-date">
          <v-icon left>mdi-calendar</v-icon>
          Date
        </v-tab>
        <v-tab href="#tab-time" :disabled="!date">
          <v-icon left>mdi-clock-outline</v-icon>
          Time
        </v-tab>
      </v-tabs>
      <v-divider />
      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-date">
          <v-date-picker
            dense
            label="Select Date"
            v-model="date"
            v-bind="datePickerProps"
            full-width
          />
        </v-tab-item>
        <v-tab-item value="tab-time">
          <v-time-picker
            dense
            label="Select Time"
            v-model="time"
            v-bind="timePickerProps"
            :disabled="!date"
            full-width
            @click:hour="handleHour"
          />
        </v-tab-item>
      </v-tabs-items>
      <v-divider />
      <v-card-actions class="justify-space-between">
        <v-btn @click="close">Cancel</v-btn>
        <v-btn @click="done" color="primary" :disabled="!(date && time)">
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    disabled: Boolean,
    placeholder: String,
    outlined: Boolean,
    required: Boolean,
    rounded: Boolean,
    dense: Boolean,
    label: String,
    rules: Array,
    className: String,
    prependInnerIcon: String,
    timePickerProps: Object,
    datePickerProps: Object
  },
  computed: {
    showedValue () {
      return this.value
        ? (this.value.date || '') + ' ' + (this.value.time || '')
        : ''
    }
  },
  data () {
    return {
      dialog: false,
      tab: 'tab-date',
      date: null,
      time: null
    }
  },
  watch: {
    date (val) {
      if (val) {
        this.$emit('date', val)
        this.time = null
        this.tab = 'tab-time'
      }
    },
    time (val) {
      this.$emit('time', val)
    }
  },
  methods: {
    close () {
      this.dialog = false
      this.$emit('cancel')
    },
    done () {
      this.$emit('input', { date: this.date, time: this.time })
      this.close()
    },
    init () {
      if (this.value) {
        this.date = this.value.date
        this.time = this.value.time
      }
    },
    handleHour (hour) {
      this.$emit('hour', hour)
    }
  },
  created () {
    this.init()
  }
}
</script>
